import _ from 'lodash';
import { createSelector } from 'reselect';

import {
  allRelatedSelector,
  listClientRequestableSelector,
} from 'modules/job-types/duck';

const profileSelector = state => state.users.profiles;

export const proSelector = createSelector(profileSelector, users => users.pro);

export const proJobTypesSelector = createSelector(
  proSelector,
  listClientRequestableSelector,
  allRelatedSelector,
  (pro, jobTypes, related) => {
    if (pro.enabledJobTypes) {
      if (pro.enabledJobTypes.length > 1) {
        return pro.enabledJobTypes;
      } else if (pro.enabledJobTypes.length === 1) {
        return [
          ...pro.enabledJobTypes,
          ...(related[pro.enabledJobTypes[0].id] || []),
        ];
      }
    }

    return jobTypes;
  },
);

export const proMainJobTypeSelector = createSelector(
  proSelector,
  listClientRequestableSelector,
  (pro, jobTypes) => {
    const mainJobType = _.get(pro, 'proProfile.mainJobType');
    return _.find(jobTypes, jt => jt.id === mainJobType);
  },
);

export const proNameSelector = createSelector(proSelector, pro =>
  _.get(pro, 'name', ''),
);

export const isValidItpProSelector = createSelector(
  proSelector,
  pro =>
    pro.isItp &&
    !pro.converted &&
    _.has(pro, 'proProfile.enabledJobTypesArray') &&
    pro.proProfile.enabledJobTypesArray.length > 0,
);
